<template>
  <b-modal
    title="Hủy đề nghị cấp cứu"
    v-model="visible"
    :busy="busy"
    scrollable
    no-close-on-esc
    no-close-on-backdrop
    no-enforce-focus
    size="lg"
    @ok="submit"
    @hidden="hide"
  >
    <div class="row">
      <div class="col-md">
        <b-alert show variant="warning">
          Hủy đề nghị cấp cứu
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <form-textarea label="Ghi chú" :model="formData" attribute="note" :errors="formErrors" :row="5"></form-textarea>
        <form-checkbox
          :model="formData"
          :errors="formErrors"
          attribute="isConfirmed"
          :chk-label="`Hủy đề nghị cấp cứu đối với các bệnh nhân dưới đây`"
        ></form-checkbox>
      </div>
    </div>
    <div class="row">
      <benh-nhan-list-preview :listBenhNhan="listBenhNhan"></benh-nhan-list-preview>
    </div>
    <template #modal-ok>
      <b-spinner v-if="busy" small variant="primary"></b-spinner>
      {{ $t('send') }}
    </template>
    <template #modal-cancel>
      {{ $t('cancel') }}
    </template>
  </b-modal>
</template>

<script>
import BenhNhanListPreview from '../components/BenhNhanListPreview.vue';
import {DEFAULT_SWAL_FAILURE_OPTIONS, DEFAULT_SWAL_SUCCESS_OPTIONS, getErrorMessage} from '../utils/emergencyUtils';

const DEFAULT_FORM_DATA = Object.freeze({
  note: '',
  isConfirmed: false,
});

export default {
  components: {
    BenhNhanListPreview,
  },
  data() {
    return {
      visible: false,
      busy: false,
      listBenhNhan: [],
      formData: DEFAULT_FORM_DATA,
      formErrors: [],
    };
  },
  methods: {
    show(listBenhNhan) {
      this.visible = true;
      this.listBenhNhan = listBenhNhan;
      this.formData = {...DEFAULT_FORM_DATA};
      this.formErrors = [];
    },

    hide() {
      this.visible = false;
      this.listBenhNhan = [];
      this.formData = {...DEFAULT_FORM_DATA};
      this.formErrors = [];
    },

    validate() {
      this.formErrors = [];
      if (this.formData.isConfirmed === false) {
        this.formErrors.push({
          msg: 'Vui lòng đánh dấu vào ô xác nhận',
          param: 'isConfirmed',
        });
      }
    },

    async submitOne(benhNhan) {
      const response = await this.$service({
        url: `/benh-nhan-emergency/cancel-emergency-request/${benhNhan._id}`,
        method: 'POST',
        data: {
          note: this.formData.note,
        },
      });
      if (!response.data) {
        throw new Error(JSON.stringify(response, null, 2));
      }
    },

    async submit(event) {
      event.preventDefault();
      this.validate();
      if (this.formErrors.length > 0) return;

      this.busy = true;
      try {
        for (const benhNhan of this.listBenhNhan) {
          await this.submitOne(benhNhan);
        }
        this.$swal({
          ...DEFAULT_SWAL_SUCCESS_OPTIONS,
          title: 'Hủy đề nghị cấp cứu thành công',
          text: `Đã hoàn thành ${this.listBenhNhan.length} bệnh nhân`,
        });
      } catch (error) {
        this.$swal({
          ...DEFAULT_SWAL_FAILURE_OPTIONS,
          title: 'Hủy đề nghị cấp cứu thất bại',
          text: getErrorMessage(error),
        });
      } finally {
        this.busy = false;
        this.visible = false;
        this.$bus.$emit('reloadBenhNhanList');
      }
    },
  },
};
</script>
